import PropTypes from 'prop-types';

export const OrdersListDefaultProps = {
  handleSort: () => null,
  isFetching: false,
  orders: null,
  params: {},
  sorts: [],
};

export const OrdersListPropTypes = {
  handleSort: PropTypes.func,
  isFetching: PropTypes.bool,
  orders: PropTypes.arrayOf(PropTypes.shape({})),
  params: PropTypes.shape({}),
  sorts: PropTypes.arrayOf(PropTypes.shape({})),
};
